export default __webpack_public_path__ + "static/media/qsp.94a7a41c.svg";